import { useId } from "react";
import type { InputHTMLAttributes, ReactNode } from "react";

// Field — label + input + validation, codified. Copy (label/error/hint) is supplied
// by the consumer (from its i18n dictionary) — never inline here. The label gives the
// input its accessible NAME (kept clean — just the label); the error/hint is a sibling
// associated via aria-describedby, and `error` flips aria-invalid. Guardrail/validation
// logic stays server-side; this only DISPLAYS it.
export function Field({
  label,
  error,
  hint,
  className,
  ...input
}: InputHTMLAttributes<HTMLInputElement> & {
  label: ReactNode;
  error?: ReactNode;
  hint?: ReactNode;
}) {
  const msgId = useId();
  const message = error ?? hint;
  return (
    <div className={`ui-field${className ? ` ${className}` : ""}`}>
      <label>
        {label}
        <input
          className="ui-input"
          aria-invalid={error ? true : undefined}
          aria-describedby={message ? msgId : undefined}
          {...input}
        />
      </label>
      {message ? (
        <span id={msgId} className={error ? "field-error" : "muted"}>
          {message}
        </span>
      ) : null}
    </div>
  );
}
